export class LicenseReactivateSimulationResponse {

    ReactivatePossible: boolean;
    ReactivateNotPossibleReason: string;

    InGraceReactivation: boolean;

    ProductPrice: number;
    SetupPrice: number;
    TotalPrice: number;
    Credit: number;
    Total: number;

    NextBillingDate: Date;


    public static FixDate(item: LicenseReactivateSimulationResponse) {
        item.NextBillingDate = new Date(item.NextBillingDate);
    }
}
